export const GET_PIPELINE_LIST_REQUEST = "GET_PIPELINE_LIST_REQUEST";
export const GET_PIPELINE_LIST_SUCCESS = "GET_PIPELINE_LIST_SUCCESS";
export const GET_PIPELINE_LIST_FAIL = "GET_PIPELINE_LIST_FAIL";
